import React, { useState } from 'react';
import { GiCheckMark } from 'react-icons/gi';
import { IoArrowBackOutline } from 'react-icons/io5';
import Button from '../Button';
import { PlansStyle } from './PlanSection.styles';
import { useNavigate } from 'react-router-dom';

const PlanSection = () => {
  // 1. Track active tab
  const [activeTab, setActiveTab] = useState('monthly');
  const navigate = useNavigate();

  // 2. Plans data
  const plans = {
    monthly: [
      {
        title: 'Free',
        desc: 'Explore AI with basic Q&A.',
        price: '$0',
        billed: 'Billed monthly',
        buttonText: 'Current',
        buttonVariant: 'secondary-outline',
        features: ['Limited basic queries', 'Real-time answers powered by live web search'],
      },
      {
        title: 'Pro',
        desc: 'Meet all your personal goals with expanded access to AI Agents.',
        price: '$20',
        billed: 'monthly, billed $180/year',
        buttonText: 'Get Pro',
        buttonVariant: '',
        features: [
          'Access to all AI models from OpenAI, Anthropic, DeepSeek, Google, and more',
          'Unlock Research and custom agents',
          'Upload files & images to extract insights',
        ],
      },
      {
        title: 'Max',
        desc: 'Supercharge your productivity with the best of AI, including ARI access.',
        price: '$200',
        billed: 'monthly, billed $2100/year',
        buttonText: 'Get Max',
        buttonVariant: '',
        features: [
          'Everything in Pro',
          'Unlimited ARI Reports',
          'Increased file upload capacity for richer research and more complex tasks',
          'Zero data retention and no-training for models',
        ],
      },
    ],
    yearly: [
      {
        title: 'Free',
        desc: 'Explore AI with basic Q&A.',
        price: '$0',
        billed: 'Billed monthly',
        buttonText: 'Current',
        buttonVariant: 'secondary-outline',
        features: ['Limited basic queries', 'Real-time answers powered by live web search'],
      },
      {
        title: 'Pro',
        desc: 'Meet all your personal goals with expanded access to AI Agents.',
        price: '$20',
        billed: 'monthly, billed $180/year',
        buttonText: 'Get Pro',
        buttonVariant: '',
        features: [
          'Access to all AI models from OpenAI, Anthropic, DeepSeek, Google, and more',
          'Upload files & images to extract insights',
        ],
      },
      {
        title: 'Max',
        desc: 'Supercharge your productivity with the best of AI, including ARI access.',
        price: '$200',
        billed: 'monthly, billed $2100/year',
        buttonText: 'Get Max',
        buttonVariant: '',
        features: [
          'Everything in Pro',
          'Unlimited ARI Reports',
          'Increased file upload capacity for richer research and more complex tasks',
          'Zero data retention and no-training for models',
        ],
      },
    ],
  };

  return (
    <PlansStyle>
      <button type="button" className="btn-back" onClick={() => navigate(-1)}>
        <IoArrowBackOutline />
      </button>

      {/* Header with tabs */}
      <div className="header">
        <h1>Upgrade your plan</h1>
        <div className="tab-btns">
          <button className={`btn ${activeTab === 'monthly' ? 'active' : ''}`} onClick={() => setActiveTab('monthly')}>
            Monthly
          </button>
          <button className={`btn ${activeTab === 'yearly' ? 'active' : ''}`} onClick={() => setActiveTab('yearly')}>
            Yearly
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        <div className="plan-wrap">
          {plans[activeTab].map((plan, index) => (
            <div className="plan-col" key={index}>
              <div className="text-box">
                <strong className="title">{plan.title}</strong>
                <p>{plan.desc}</p>

                <div className="price-box">
                  <strong className="price">{plan.price}</strong>
                  <span className="text">{plan.billed}</span>
                </div>
              </div>
              <Button width="100%" variant={plan.buttonVariant}>
                {plan.buttonText}
              </Button>
              <ul className="feature-list">
                {plan.features.map((f, i) => (
                  <li key={i}>
                    <GiCheckMark className="icon" /> {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      {/* <div className="footer">
        <div className="text-holder">
          <PiBuildingOfficeLight size="28" />
          <p>For businesses looking to empower their workforce with AI, learn about our Enterprise Plan.</p>
          <Button width="150px" variant="secondary">
            Book demo
          </Button>
        </div>
      </div> */}
    </PlansStyle>
  );
};

export default PlanSection;
